import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) => createStyles({
  wrapper: {
    display: 'flex',
    gap: '24px',
    padding: '32px',
    [theme.breakpoints.down('md')]: {
      padding: '20px',
    },
  },
  section: {
    width: '100%',
  },
  errorTextMessage: {
    marginTop: '10px',
    color: theme.palette.error.main,
  },
  wrapperPadding: {
    padding: '21px 30px',
  },
  wrapperPaddingIframe: {
    display: 'flex',
    flexDirection: 'column',
    padding: '21px 30px',
    height: '100%',
    maxHeight: '540px',
    overflow: 'hidden',
    '& .content': {
      height: '100%',
    },
  },
  appendClassName: {
    paddingTop: '15px',
  },
  isDoneWrapper: {
    padding: '20px 0px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  isDoneWrapperMarketplace: {
    width: '310px',
    textAlign: 'center',
    color: '#000',
    margin: '0 auto',
  },
  isDoneText: {
    fontSize: '20px',
    fontWeight: 'bold',
    marginTop: '20px',
  },
  isDoneTextMarketplace: {
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '20px',
    marginTop: '16px',
  },
  modalWrapperContent: {
    maxWidth: 920,
    borderRadius: '8px',
    padding: 0,
    [theme.breakpoints.down('md')]: {
      overflow: 'initial',
    },
    [theme.breakpoints.up('md')]: {
      padding: 'unset',
    },
    '&.CustomWrapperDone': {
      maxWidth: 840,
    },
  },
  moduleWrapperContentHeader: {
    padding: '10px 50px',
    minHeight: '40px',
    marginBottom: '20px',
  },
  modalWrapperContentHeaderIframe: {
    padding: '10px 50px',
    minHeight: '40px',
    marginBottom: '20px',
  },
  modalWrapperContentHeader: {
    marginBottom: 'unset',
    minHeight: 'unset',
    padding: '20px 32px',
    borderBottom: '1px solid rgba(30, 30, 30, 0.10)',
    height: '60px',
    '& h3': {
      margin: 'unset',
      fontSize: '16px',
      fontWeight: '500',
      lineHeight: '20px',
      [theme.breakpoints.down('md')]: {
        fontSize: '14px',
      },
    },
    [theme.breakpoints.down('md')]: {
      padding: '12px 20px',
      height: '44px',
    },
  },
  modalCustomCloseButton: {
    top: '10px',
    backgroundColor: 'unset',
    color: '#787878',
    [theme.breakpoints.down('md')]: {
      top: '0',
      right: '5px',

      '& svg': {
        width: '32px',
        height: '32px',
      },
    },

    '& svg': {
      width: '32px',
      height: '32px',
    },
  },
  termsAndConditionsWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '24px',
    width: '100%',
    minHeight: '92px',
    padding: '20px 32px',
    borderTop: '1px solid rgba(30, 30, 30, 0.10)',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      padding: '12px 20px',
    },
  },
  termsAndConditions: {
    width: '50%',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '16px',
    color: '#737373',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      fontSize: '12px',
    },
  },
  sendButton: {
    padding: '20px 10px',
    textTransform: 'none',
    width: '50%',
    height: '52px',
    borderRadius: '0px',
    backgroundColor: '#ED1C24',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: '44px',
      fontSize: '14px',
    },
  },
  sendButtonMobile: {
    padding: '20px 10px',
    width: '50%',
    height: '52px',
    borderRadius: '0px',
    backgroundColor: '#ED1C24',
  },
  underlined: {
    cursor: 'pointer',
    borderBottom: '1px solid',
  },
}));
